{
  "tabs": {
    "chat": "Chat",
    "reminders": "Pripomienky",
    "calendar": "Kalendár",
    "settings": "Nastavenia"
  },
  "common": {
    "cancel": "Zrušiť",
    "save": "Uložiť",
    "confirm": "Potvrdiť",
    "delete": "Vymazať",
    "back": "Späť",
    "close": "Zavrieť",
    "edit": "Upraviť",
    "search": "Hľadať",
    "all": "Všetko",
    "loading": "Načítavam...",
    "error": "Niečo sa pokazilo",
    "notFound": "Nenašlo sa",
    "tryAgain": "Skúste znova",
    "retry": "Opakovať",
    "undo": "Späť",
    "pullToRefresh": "Potiahnite pre obnovenie",
    "justNow": "práve teraz"
  },
  "auth": {
    "welcome": "Vitajte vo FishMemory",
    "tagline": "Váš asistent pripomienok pre WhatsApp, teraz vo vašom vrecku.",
    "subtitle": "Váš asistent pripomienok pre WhatsApp, teraz vo vašom vrecku.",
    "phoneLabel": "Vaše číslo WhatsApp",
    "phoneHint": "Pošleme overovací kód cez WhatsApp",
    "invalidPhone": "Zadajte platné telefónne číslo",
    "continue": "Pokračovať",
    "enterPhone": "Zadajte svoje číslo WhatsApp",
    "phonePlaceholder": "Telefónne číslo",
    "sendCode": "Poslať kód",
    "verifyTitle": "Overte svoje číslo",
    "otpSentTo": "6-miestny kód bol odoslaný na {{phone}} cez WhatsApp",
    "enterFullCode": "Zadajte všetkých 6 číslic",
    "invalidOtp": "Neplatný kód. Skúste znova.",
    "otpFailed": "Nepodarilo sa odoslať kód. Skúste znova.",
    "otpResent": "Kód znovu odoslaný",
    "resendIn": "Znova odoslať o {{seconds}} s",
    "resendCode": "Znova odoslať kód",
    "enterOtp": "Zadajte kód zaslaný na WhatsApp",
    "verify": "Overiť",
    "resend": "Znova odoslať kód",
    "wrongNumber": "Nesprávne číslo?",
    "backToPhone": "Späť na číslo",
    "editPhone": "Upraviť číslo",
    "error": "Chyba",
    "setupTitle": "Nastavme to",
    "setupSubtitle": "Tieto nastavenia môžete kedykoľvek zmeniť v Nastaveniach",
    "namePlaceholder": "Vaše meno",
    "letsGo": "Dokončiť nastavenie",
    "skipForNow": "Preskočiť teraz"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Napíšte správu...",
    "inputPlaceholder": "Napíšte správu...",
    "typing": "FishMemory píše...",
    "online": "Online",
    "connecting": "Pripájanie...",
    "reconnecting": "Znovu pripájanie...",
    "offline": "Offline",
    "empty": "Začnite konverzáciu",
    "emptyHint": "Vytvárajte pripomienky, kontrolujte plán alebo požiadajte o pomoc.",
    "emptyAction": "Poslať ukážkovú pripomienku",
    "actions": "Akcie chatu",
    "keep": "Uložiť správy",
    "clearTitle": "Vyčistiť chat",
    "clearConfirm": "Vymazať všetky správy z tohto zariadenia? Toto sa nedá vrátiť späť.",
    "clear": "Vyčistiť chat",
    "optionSelected": "Vybrané: {{label}}",
    "sendingSelection": "Odosielam...",
    "connectionLost": "Znovu pripájam..."
  },
  "reminders": {
    "title": "Moje pripomienky",
    "active": "Aktívne",
    "today": "Dnes",
    "thisWeek": "Tento týždeň",
    "history": "História",
    "items": "položiek",
    "emptyTitle": "Zatiaľ žiadne pripomienky",
    "emptySubtitle": "Vytvorte jednu v chate a zobrazí sa tu.",
    "emptyAction": "Otvoriť chat",
    "filterActive": "Aktívne",
    "filterToday": "Dnes",
    "filterWeek": "Tento týždeň",
    "filterHistory": "História",
    "emptyState": "Zatiaľ žiadne pripomienky. Začnite chatovať!",
    "swipeDone": "Hotovo",
    "swipeSnooze": "Odložiť",
    "swipeDelete": "Vymazať",
    "search": "Hľadať pripomienky...",
    "upcoming": "Nadchádzajúce",
    "completed": "Dokončené",
    "overdue": "Meškanie",
    "tomorrow": "Zajtra",
    "synced": "Synchronizované {{value}}",
    "swipeHint": "Potiahnite pripomienku pre viac akcií",
    "noResults": "Žiadne pripomienky nezodpovedajú vyhľadávaniu",
    "noResultsHint": "Skúste iné kľúčové slovo alebo vymažte vyhľadávanie",
    "deleteAllFailed": "Nepodarilo sa vymazať všetky pripomienky"
  },
  "calendar": {
    "title": "Kalendár",
    "today": "Dnes",
    "tomorrow": "Zajtra",
    "completed": "hotovo",
    "noEvents": "Žiadne udalosti",
    "noEventsSubtitle": "Vyberte dátum pre zobrazenie pripomienok a udalostí v kalendári.",
    "googleEvent": "Google Kalendár",
    "legendActive": "Aktívne",
    "legendRecurring": "Opakujúce sa",
    "legendDone": "Hotovo",
    "legendGoogle": "Google",
    "previousMonth": "Predchádzajúci mesiac",
    "nextMonth": "Nasledujúci mesiac",
    "previousYear": "Predchádzajúci rok",
    "nextYear": "Nasledujúci rok",
    "goToToday": "Prejsť na dnes",
    "all": "Všetko",
    "active": "Aktívne",
    "done": "Hotovo",
    "paused": "Pozastavené"
  },
  "settings": {
    "title": "Nastavenia",
    "profile": "Profil",
    "name": "Zobrazované meno",
    "enterName": "Zadajte meno",
    "language": "Jazyk",
    "uiLanguage": "Jazyk aplikácie",
    "uiLanguageHelp": "Mení jazyk rozhrania, označenia kalendára a smer rozloženia len na tomto zariadení.",
    "serverLanguage": "Jazyk chatu",
    "serverLanguageHelp": "Mení jazyk odpovedí servera a správ pripomienok pre váš účet.",
    "timezone": "Časové pásmo",
    "currentTimezone": "Aktuálne časové pásmo",
    "timezoneHelp": "Všetky časy pripomienok sú zobrazené podľa tohto časového pásma.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Uložiť časové pásmo",
    "timezoneSaved": "Časové pásmo aktualizované",
    "detect": "Detekovať",
    "detectFailed": "Nepodarilo sa zistiť časové pásmo",
    "autoDetect": "Automaticky z GPS",
    "notifications": "Notifikácie",
    "notificationsHelp": "Opakované pripomienky ovládajú opakované upozornenia po doručení pripomienky. Povolenia notifikácií na úrovni zariadenia spravujete v nastaveniach telefónu.",
    "pushEnabled": "Push notifikácie",
    "autoDoneOnFire": "Automaticky označiť ako splnené po spustení",
    "autoDoneOnFireDesc": "Ak je vypnuté, pripomienky zostanú aktívne, kým ich neoznačíte ako splnené.",
    "googleCalendar": "Google Kalendár",
    "google": "Google Kalendár",
    "googleConnected": "Pripojené",
    "googleDisconnected": "Nie je pripojené",
    "googleConnectedHelp": "Nové pripomienky môžu byť automaticky synchronizované s kalendárom.",
    "googleDisconnectedHelp": "Pripojte Google Kalendár, aby ste mali pripomienky a udalosti zosúladené.",
    "googleConnectFailed": "Nepodarilo sa pripojiť Google Kalendár",
    "connected": "Pripojené",
    "disconnected": "Nie je pripojené",
    "connect": "Pripojiť",
    "disconnect": "Odpojiť",
    "autoSync": "Automatická synchronizácia nových pripomienok",
    "autosync": "Automatická synchronizácia nových pripomienok",
    "subscription": "Predplatné",
    "trialUsed": "Skúška: {{used}}/{{total}} využitých",
    "trialStatus": "Skúšobná verzia dostupná",
    "activeStatus": "Aktívne predplatné",
    "expiredStatus": "Predplatné vypršalo",
    "unsubscribedStatus": "Nie ste prihlásený",
    "about": "O aplikácii",
    "version": "Verzia",
    "logout": "Odhlásiť sa",
    "logoutTitle": "Odhlásiť sa",
    "logoutConfirm": "Naozaj sa chcete odhlásiť?",
    "noName": "Nie je nastavené meno",
    "serverConnection": "Pripojenie k serveru",
    "serverUrl": "URL servera",
    "serverEdit": "Upraviť",
    "saveReconnect": "Uložiť a znovu pripojiť",
    "resetDefault": "Obnoviť predvolené",
    "invalidServerUrlTitle": "Neplatná URL servera",
    "invalidServerUrlMessage": "Zadajte platnú URL servera s http alebo https, napríklad https://example.com",
    "uiLanguageChangeFailed": "Nepodarilo sa zmeniť jazyk aplikácie. Skúste znova.",
    "serverLanguageChangeFailed": "Nepodarilo sa zmeniť jazyk chatu. Skúste znova.",
    "timezoneChangeFailed": "Nepodarilo sa zmeniť časové pásmo. Skúste znova.",
    "autoSyncChangeFailed": "Nepodarilo sa aktualizovať automatickú synchronizáciu. Skúste znova.",
    "nameChangeFailed": "Nepodarilo sa aktualizovať zobrazované meno. Skúste znova.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Detaily pripomienky",
    "editTime": "Upraviť čas",
    "rename": "Premenovať",
    "snooze": "Odložiť",
    "snooze15": "Odložiť o 15 minút",
    "pause": "Pozastaviť",
    "pauseReminder": "Pozastaviť pripomienku",
    "resume": "Pokračovať",
    "resumeReminder": "Pokračovať v pripomienke",
    "skip": "Preskočiť ďalšiu",
    "skipOccurrence": "Preskočiť túto udalosť",
    "syncGoogle": "Synchronizovať s Google",
    "delete": "Vymazať",
    "deleteTitle": "Vymazať pripomienku",
    "deleteConfirm": "Táto pripomienka bude trvalo vymazaná.",
    "deleteRecurringTitle": "Vymazať opakujúcu sa pripomienku",
    "deleteRecurringMessage": "Chcete preskočiť túto udalosť alebo vymazať celú sériu?",
    "deleteThisOccurrence": "Preskočiť túto udalosť",
    "deleteEntireSeries": "Vymazať celú sériu",
    "done": "Hotovo",
    "markDone": "Označiť ako splnené",
    "undo": "Obnoviť",
    "undoPrompt": "Potrebujete ju znova aktívnu? Obnovte ju teraz.",
    "recurring": "Opakujúce sa",
    "nextRun": "Ďalšie spustenie",
    "oneTime": "Jednorazové",
    "pending": "Čaká",
    "sent": "Odoslané",
    "paused": "Pozastavené",
    "active": "Aktívne",
    "snoozed": "Odložené",
    "localTime": "Zobrazené vo vašom miestnom čase",
    "recurrence": "Opakovanie",
    "created": "Vytvorené",
    "tags": "Štítky",
    "fireCount": "Počet spustení",
    "actions": "Akcie",
    "none": "Žiadne",
    "snoozeFailed": "Nepodarilo sa odložiť pripomienku",
    "pauseFailed": "Nepodarilo sa pozastaviť pripomienku",
    "resumeFailed": "Nepodarilo sa pokračovať v pripomienke",
    "skipFailed": "Nepodarilo sa preskočiť pripomienku",
    "doneFailed": "Nepodarilo sa označiť pripomienku ako splnenú",
    "undoFailed": "Nepodarilo sa obnoviť stav pripomienky",
    "deleteFailed": "Nepodarilo sa vymazať pripomienku",
    "rescheduleTitle": "Preplánovať?",
    "rescheduleMsg": "Táto pripomienka mešká. Chcete ju preplánovať?",
    "reschedule15": "O 15 minút",
    "reschedule60": "O 1 hodinu",
    "keepOverdue": "Nechať tak"
  },
  "onboarding": {
    "slide1Title": "Vitajte vo FishMemory",
    "slide1Sub": "Váš osobný asistent pripomienok — poháňaný WhatsAppom a stvorený pre vaše vrecko.",
    "slide2Title": "Len prirodzene chatovať",
    "slide2Sub": "Napíšte pripomienky tak, ako myslíte: „Pripomeň mi zavolať mame zajtra o 15:00“ — o zvyšok sa postaráme.",
    "slide3Title": "Nikdy nič nezmeškajte",
    "slide3Sub": "Dostávajte včasné upozornenia, organizujte pomocou štítkov a majte prehľad o všetkom, čo je dôležité.",
    "getStarted": "Začať",
    "next": "Ďalej",
    "firstReminderTitle": "Vytvorte svoju prvú pripomienku!",
    "firstReminderHint": "Skúste napísať napríklad:",
    "firstReminderExample": "Pripomeň mi napiť vodu zajtra o 9:00",
    "gotIt": "Rozumiem!",
    "notifRationaleTitle": "Buďte včas",
    "notifRationaleBody": "FishMemory potrebuje notifikácie, aby vás pripomínal načas. Dostanete upozornenia len na pripomienky, ktoré vytvoríte.",
    "notifRationaleAllow": "Povoliť notifikácie",
    "notifRationaleLater": "Možno neskôr",
    "swipeHint": "Potiahnite doprava pre rýchle akcie →",
    "calendarDragHint": "Potiahnite pre rozšírenie ↕"
  }
}
